window.VegasCart = {
	add: function (lparams, callback) {
		let params = {
			id: lparams.id,
			cnt: lparams.cnt,
			_token: App.csrf
		};

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	remove: function (lparams, callback) {
		let params = {
			id: lparams.id,
			pivot_id: lparams.pivot_id,
			_token: App.csrf
		};

		this.removeRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data);

				if (typeof callback == 'function')
					callback(data);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},
	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},
	changeProductDataRequest: function (params, callback) {
		$.post('/cart/change_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);

			if (!data.error) {
				VegasCart.total(data);
			}
		});
	},

	changeCnt: function (params, callback) {
		params.push({name: '_token', value: App.csrf});
		this.changeProductDataRequest(params, callback);
	},


	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter="products-count"]').attr('data-cnt', data.products_count).fadeIn();
		}

		if (typeof data.cart_sum !== 'undefined') {
			$('[data-cart][data-counter="cart-total"]').text(output_money(data.cart_sum));
		}
	},
};

$(document).ready(function () {
	let $window = $(window),
		$body = $('body'),
		$document = $(document)
	;

	$document.on('click', '.vg-shop-product [data-cart][data-action="add"]', function () {
		var id = $(this).closest('.vg-shop-product').data('id');

		VegasCart.add({
			id: id
		}, function (data) {
			$('.vg-shop-product[data-id="' + data.product.id + '"]').addClass('in-cart')
		});

		return false;
	});

	$document.on('click', '.vg-shop-product [data-cart][data-action="del"]', function () {
		var id = $(this).closest('.vg-shop-product').data('id');

		VegasCart.remove({
			id: id
		}, function (data) {
			$('.vg-shop-product[data-id="' + id + '"]').removeClass('in-cart')
		});

		return false;
	});

	$document.on('click', '.table-serie-products [data-cart][data-action="add"]', function () {
		let $self = $(this),
			id = $self.closest('tr[data-id]').data('id');

		VegasCart.add({
			id: id
		}, function (data) {
			$('.table-serie-products tr[data-id="' + id + '"]').addClass('in-cart');
		});

		return false;
	});
	$document.on('click', '.table-serie-products [data-cart][data-action="del"]', function () {
		let $self = $(this),
			id = $self.closest('tr[data-id]').data('id');

		VegasCart.remove({
			id: id
		}, function (data) {
			$('.table-serie-products tr[data-id="' + id + '"]').removeClass('in-cart');
		});

		return false;
	});

	// изменение кол-ва товара в корзине
	$document.on('change-counter', '.vg-shop-cart--table [data-toggle="input-counter"]', function () {
		let $item = $(this).closest('[data-item]'),
			cnt = $(this).find('input').val(),
			pivot_id = $item.data('pivot_id'),
			params = extendsFormParams(
				$("#form-cart").serializeArray(),
				{pivot_id: pivot_id, cnt: cnt}
			);

		VegasCart.changeCnt(params, function (data) {
			if (data.product_sum) {
				$item.find('.price-total').html(data.product_sum_formatted);
			}
		});
	});

	// удаление товара из корзины
	$document.on('click', '.vg-shop-cart--table [data-cart][data-action=remove]', function () {
		let $item = $(this).closest('[data-item]'),
			pivot_id = $item.data('pivot_id');

		if (confirm('Вы действительно хотите убрать товар из корзины?')) {
			VegasCart.remove(
				{
					pivot_id: pivot_id,
				},
				function (data) {
					$item.remove();

					if (!data.products_count) {
						location.reload();
					}
				}
			);
		}

		return false;
	});

	$document.on('input change', '.vg-shop-cart .promocode #promo_code', function () {
		var params = {
			code: $(this).val()
		};

		var $container = $(this).closest('.promocode');

		$.get('/cart/check_promocode', params, function (data) {
			$container.find('.success-msg, .error-msg').hide();

			if (data.error) {
				$container.find('.error-msg').html(data.msg).show();
			} else {
				$container.find('.success-msg .discount').html(data.discount).show();
				$container.find('.success-msg').show();
				$container.find('.set-promocode').show();
			}
		});

		return false;
	});
});